export const styles = () => ({
  button: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '20px',
    padding: '8px 4px',
    width: 102,
    boxSizing: 'border-box',
    textAlign: 'center',
    borderRadius: '4px',
    color: '#1658F3',
    border: 0,
    background: 'none',
    cursor: 'pointer',
  },
  primary: {
    color: '#fff',
    background: '#1658F3',
  },
  attention: {
    color: '#FF6666',
  },
})
